export const MODAL_TYPES = {
  share_video: 'SHARE_VIDEO',
  external_sharing: 'ExternalSharing',
  create_channel: 'CREATE_CHANNEL',
  select_playlist: 'SELECT_PLAYLIST',
  create_playlist: 'CREATE_PLAYLIST',
  date_picker: 'DATE_PICKER',
  channel_member: 'CHANNEL_MEMBER',
  collection: 'COLLECTION',
  profile: 'PROFILE',
  edit_speaker_profile: 'EDIT_SPEAKER_PROFILE',
  profile_image_upload: 'PROFILE_IMAGE_UPLOAD',
  remove_profile_image: 'REMOVE_PROFILE_IMAGE',
  resource_link: 'RESOURCE_LINK',
  resource_file: 'RESOURCE_FILE',
  remove_resource: 'REMOVE_RESOURCE',
  trim_save_changes: 'TRIM_SAVE_CHANGES',
  trim_alert: 'TRIM_ALERT',
  trim_revert_changes: 'TRIM_REVERT_CHANGES',
  background_upload: 'BACKGROUND_UPLOAD',
  background_save_changes: 'BACKGROUND_SAVE_CHANGES',
  external_polls: 'EXTERNAL_POLLS',
  poll_display: 'POLL_DISPLAY',
  poll_save_changes: 'POLL_SAVE_CHANGES',
  duplicated_display_time: 'DUPLICATED_DISPLAY_TIME',
  channel_members: 'CHANNEL_MEMBERS',
  add_people: 'ADD_PEOPLE',
  remove_channel_people: 'REMOVE_CHANNEL_PEOPLE',
  remove_video_shot: 'REMOVE_VIDEO_SHOT',
  delete_video: 'DELETE_VIDEO',
  edit_summary: 'EDIT_SUMMARY',
  remove_summary: 'REMOVE_SUMMARY',
  add_speaker: 'ADD_SPEAKER',
  chapter_summary: 'CHAPTER_SUMMARY',
  statistics: 'STATISTICS'
};

export const MODAL_ANIMATIONS = {
  fade: 'fade',
  unfold: 'unfold',
  pulse: 'pulse',
  spin: 'spin',
  runner: 'runner'
};
